import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { EpisodeCategory } from '../enums';

export type DeclarationsExportValidated = {
    batchId: string | null;
    episodeCategory: EpisodeCategory;
    episodeCategoryId: string;
    insurerId: string | null;
    isPreview?: boolean;
    serviceIds: string | null;
    startedBeforeDate: string | null;
};

export const declarationsExportSchema: ISchemaContainer<DeclarationsExportValidated> = {
    schema: Koi.alternatives()
        .conditional(Koi.object({ batchId: Koi.string().uuid() }), {
            then: Koi.object({
                batchId: Koi.string().uuid(),
            }),
            // eslint-disable-next-line sort-keys
            otherwise: Koi.object({
                batchId: Koi.valid(null),
                episodeCategory: Koi.koi().enum(EpisodeCategory),
                episodeCategoryId: Koi.string().uuid(),
                insurerId: Koi.string().uuid().allow(null),
                isPreview: Koi.boolean(),
                serviceIds: Koi.when('episodeCategory', {
                    is: Koi.valid(EpisodeCategory.somnology, EpisodeCategory.allergology, EpisodeCategory.audiology),
                    then: Koi.array().length(0),
                    // eslint-disable-next-line sort-keys
                    otherwise: Koi.array().items(Koi.string().uuid()).min(1).required(),
                }),
                startedBeforeDate: Koi.koi().date(),
            }),
        })
        .options({ convert: false, presence: 'required' }),
};
